import React from 'react';
import { FormControl, FormLabel } from '@material-ui/core/';
import PropTypes from 'prop-types';

const FormRadioButton = ({ input, meta: { error, touched }, ...rest }) => (
  <div>
    <FormControl component="fieldset" {...input} {...rest} />
    <div>
      {error && touched && (
        <FormLabel error style={{ fontSize: 12, marginTop: 10 }}>
          {error}
        </FormLabel>
      )}
    </div>
  </div>
);

FormRadioButton.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  rest: PropTypes.object,
};

export default FormRadioButton;
